/**
 * webview_flutter: WebViewController.addJavaScriptChannel("CaptchaResult", ...)
 * H5 侧通过 CaptchaResult.postMessage(字符串) 回传结果。
 */
export function postCaptchaResultToFlutter(
  payload: Record<string, unknown>
): void {
  const json = JSON.stringify(payload);
  try {
    const ch = (
      window as unknown as { CaptchaResult?: { postMessage(s: string): void } }
    ).CaptchaResult;
    if (ch && typeof ch.postMessage === "function") {
      ch.postMessage(json);
      return;
    }
  } catch (e) {
    console.error(e);
  }
  console.log("[CaptchaResult 未注入，浏览器调试用]", json);
}
